import numeral from 'numeral';

const ProjectChartsUtils = {
  countGroup(entries, field, isCounted) {
    if (isCounted == null) { isCounted = true; }
    if (isCounted) {
      return this.simpleCount(entries, field);
    } else {
      return this.sumGroupBudget(entries, field);
    }
  },

  simpleCount(entries, field) {
    let entry, key;
    const map = Object.create(null);
    if (!entries || (entries.length === 0)) { return map; }
    if (_.isArray(entries[0][field])) {
      for (entry of entries) {
        const keys = entry[field];
        for (key of keys) {
          map[key] = (map[key] || 0) + 1;
        }
      }
    } else {
      for (entry of entries) {
        key = entry[field];
        map[key] = (map[key] || 0) + 1;
      }
    }
    return map;
  },

  sumGroupBudget(entries, field) {
    let entry, key;
    const map = Object.create(null);
    if (!entries || (entries.length === 0)) { return map; }
    if (_.isArray(entries[0][field])) {
      for (entry of entries) {
        const keys = entry[field];
        for (key of keys) {
          map[key] = (map[key] || 0) + entry['formatted_budget'];
        }
      }
    } else {
      for (entry of entries) {
        key = entry[field];
        map[key] = (map[key] || 0) + entry['formatted_budget'];
      }
    }
    return map;
  },

  addOrInitSectorGroup(groups, entry) {
    _.each(entry.sectors, function (name) {
      if (groups[name] === undefined) {
        groups[name] = [entry];
      } else {
        groups[name].push(entry);
      }
    });
  },

  convertNbToString(value) {
    return numeral(value).format('($0[.]0a)');
  },

  convertToBn(value) {
    const bn = Math.abs(Number(value)) / 1.0e+9;
    return Math.round(bn * 100) / 100;
  },

  _roundToTwo(value) {
    return Math.round(value * 100) / 100;
  },

  statusColor(key) {
    const colors = {
      draft: '#343C48', submitted: '#175894', under_review: '#ef7c22', approved: '#00a57a',
      rejected: '#EF452F', expired: '#585f69', un_reviewed: '#6557b9'
    };

    return colors[key];
  },

  columnSortFunc(x, y) {
    if (this.selectedXAxis === 'years') {
      return x - y;
    } else {
      const diff = x.slice(3) - y.slice(3);
      if (diff === 0) {
        return x.slice(1, 2) - y.slice(1, 2);
      } else {
        return diff;
      }
    }
  }
};

window.convertNbToString = ProjectChartsUtils.convertNbToString;

export default ProjectChartsUtils;
